import React from 'react';
import PropTypes from 'prop-types';

import './index.sass';

const preventDefault = (e) => e.preventDefault();

const ProtectedMedia = ({ className, children, enabled }) => {
	if (!enabled) {
		return <>{children}</>;
	}

	return (
		<div
			className={`ProtectedMedia ${className}`}
			onContextMenu={preventDefault}
			onDragStart={preventDefault}
			onCopy={preventDefault}
		>
			{children}
			<div className="ProtectedMedia__shield" aria-hidden="true" />
		</div>
	);
};

ProtectedMedia.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
	enabled: PropTypes.bool,
};

ProtectedMedia.defaultProps = {
	className: '',
	enabled: true,
};

export default ProtectedMedia;
